import { useMemo } from 'react';
import PropTypes from 'prop-types';
import getNavigationItems from '../../utils/sidebar/getNavigationItems';
import isUserInUSOrUSTerritories from '../../utils/isUserInUSOrUSTerritories';
import NavigationMenuItem from './NavigationMenuItem';

const NavigationMenu = ({
  iHeartGuideId,
  userLocation,
  selectedGuideId,
  subscriptionEnabled,
}) => {
  const navigationItems = useMemo(
    () => getNavigationItems(iHeartGuideId),
    [iHeartGuideId],
  );

  return (
    <div id="sidebarNavLinks">
      {navigationItems.map((navItem) => {
        const isSelected =
          !!selectedGuideId && selectedGuideId === navItem.guideId;
        const skipIteration =
          !navItem.guideId ||
          (navItem.guideId === iHeartGuideId &&
            !isUserInUSOrUSTerritories(userLocation));

        return skipIteration ? null : (
          <NavigationMenuItem
            isSelected={isSelected}
            item={navItem}
            key={`${navItem.path}.${isSelected}`}
            subscriptionEnabled={subscriptionEnabled}
          />
        );
      })}
    </div>
  );
};

NavigationMenu.propTypes = {
  iHeartGuideId: PropTypes.string,
  userLocation: PropTypes.string,
  selectedGuideId: PropTypes.string,
  subscriptionEnabled: PropTypes.bool.isRequired,
};

export default NavigationMenu;
